module.exports = __webpack_public_path__ + "img/learner-quiz-Beluga.1840f8f9.png";